import { entitySelector } from "@libs/datasets";
import createCachedSelector from "re-reselect";
import { createSelector } from "reselect";

export const getAllEmployeeSelector = createCachedSelector(
    entitySelector,
    (resp) => resp ? (resp.map(({ id, email, firstname, middlename, lastname, ...datum }) => {
        const fullName = [firstname, middlename, lastname].filter(Boolean).join(' ');
        const label = fullName ? `${fullName} - ${email}` : email;
        return {
            label,
            value: id,
            name: fullName,
            email,
        };
    })) : []
)((state, domain, entity) => `@data-${domain}-${entity}`);

// Selector for employees fetched from /employee/get/all/preview-role-based
// Memoized with createSelector to prevent unnecessary rerenders
export const getEmployeesForCreateLeaveSelector = createSelector(
    (state) => state?.leaveManagement?.employeesForCreateLeave?.data || [],
    (employees) => 
        employees.map(({ id, firstname, middlename, lastname, user, ...datum }) => {
            const email = user?.email || datum.email || '';
            const fullName = [firstname, middlename, lastname].filter(Boolean).join(' ');
            const label = fullName ? `${fullName} - ${email}` : email;
            return {
                label,
                value: id,
                name: fullName,
                email,
            };
        })
);

export const getEmployeesForCreateLeaveLoadingSelector = (state) => {
    return state?.leaveManagement?.employeesForCreateLeave?.loading || false;
};
